import React from 'react';
var ManageSharing = require('./manage-sharing');
var ManageHighlighters = require('./manage-highlighters');
import Dispatcher from "../../dispatcher";

var ManageResources = {
  _manage: function(e, refocusDOM, titleLarge, titleSmall, content, definingClass, modalContainerHeader, modalDimensions, launchBanner, isbn){
    if (Fraction.Helpers.isSmallScreen()){
      Fraction.Helpers.showVSTModal({
        menuId: titleSmall,
        title: titleSmall,
        content: content,
        closeCallback: function(){},
        buttons: [],
        intersitial: true,
        modalContainerHeader: true,
        definingClass: definingClass,
        modalDimensions: modalDimensions,
        launchBanner: launchBanner,
        isbn: isbn
      },refocusDOM);
    } else {
      Fraction.Helpers.showVSTModal({
        menuId: titleLarge,
        title: titleLarge,
        content: content,
        closeCallback: function(){},
        buttons: [],
        modalContainerHeader: true,
        definingClass: definingClass,
        modalDimensions: modalDimensions,
        launchBanner: launchBanner,
        isbn: isbn
      },refocusDOM);
    }
  },

  _manageSharing: function(e, refocusDOM, isbn){
    ManageResources._manage(e, refocusDOM, i18n.t('sharing.sharing'), i18n.t('sharing.sharing'), <ManageSharing manageHighlighters={ManageResources._manageHighlighters} isbn={isbn} />, "sharing", false, " largeModal", false, isbn);
  },

  _manageHighlighters: function(e, refocusDOM, isbn){
    Dispatcher.emit(Dispatcher.OPEN_MODAL, 'manage-highlighters', {isbn});
  }
};

module.exports = ManageResources;
